import { RootState } from '../../types';

export const all = (state: RootState) => state.finance.payment;
export const loading = (state: RootState) => all(state).loading;
export const error = (state: RootState) => all(state).error;
export const frame = (state: RootState) => all(state).frame;
export const qr = (state: RootState) => all(state).qr;
export const transactionsAmount = (state: RootState) =>
  all(state).transactionsAmount;
